import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colorTokens';

const ProofStrip = () => {
  const { t } = useTranslation();

  const statements = [
    t('home.proofStrip.stat1'),
    t('home.proofStrip.stat2'),
    t('home.proofStrip.stat3'),
    t('home.proofStrip.stat4'),
  ];

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: colors.bgSoft,
        py: { xs: 4, md: 4 },
        borderTop: `1px solid ${colors.border}`,
        borderBottom: `1px solid ${colors.border}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 0.5, md: 1 },
          }}
        >
          {statements.map((text, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <Box
                  component="span"
                  sx={{
                    display: { xs: 'none', md: 'inline' },
                    mx: 1.5,
                    color: '#CBD5E1',
                    fontSize: '14px',
                    userSelect: 'none',
                  }}
                >
                  ·
                </Box>
              )}
              <Typography
                component="span"
                sx={{
                  fontSize: '14px',
                  color: colors.textSecondary,
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                {text}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ProofStrip;
